// extracted by mini-css-extract-plugin
export var breadcrumb = "_2-3";
export var breadcrumbArrow = "_2-4";
export var breadcrumbs = "_2-0";
export var link = "_2-5";
export var sm = "_2-1";
export var xs = "_2-2";